import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';

import { color, radio } from '#components/mobile/ui/tokens';

export type Permiso = 'ver' | 'editar';

/** La etiqueta de la fila: «Al mando», «Ver y editar» o «Solo ver». */
export function EtiquetaPermiso({ tipo }: { tipo: Permiso | 'mando' }) {
  const { t } = useTranslation();
  let estilo: CSSProperties;
  let rotulo: string;
  switch (tipo) {
    case 'mando':
      estilo = { color: color.accent, border: `1px solid ${color.accent}` };
      rotulo = t('In command');
      break;
    case 'editar':
      estilo = { color: color.accent, backgroundColor: color.accentSoft };
      rotulo = t('View and edit');
      break;
    default:
      estilo = { color: color.fg2, backgroundColor: color.surface2 };
      rotulo = t('View only');
      break;
  }
  return (
    <Text
      data-testid="etiqueta-permiso"
      style={{
        fontSize: 12,
        fontWeight: 800,
        padding: '4px 9px',
        borderRadius: radio.pildora,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        ...estilo,
      }}
    >
      {rotulo}
    </Text>
  );
}
